/**
 * svg 封装
 */

export class DrawSVG {
  ele: SVGSVGElement
  constructor(container: HTMLElement, width: number, height: number) {
    this.ele = document.createElementNS("http://www.w3.org/2000/svg", "svg")
    setAttr(this.ele, { width, height })
    container.appendChild(this.ele)
  }

  attr(options: { [key: string]: any }) {
    setAttr(this.ele, options)
  }

  /** 线段 */
  Line(x1: number, y1: number, x2: number, y2: number) {
    let newline = new Line(x1, y1, x2, y2)
    this.ele.appendChild(newline.ele)
    return newline
  }

  /** 横向线段，带像素修正 */
  HLine(x: number, y: number, width: number) {
    let newline = new HLine(x, y, width)
    this.ele.appendChild(newline.ele)
    return newline
  }

  /** 竖向线段，带像素修正 */
  VLine(x: number, y: number, height: number) {
    let newline = new VLine(x, y, height)
    this.ele.appendChild(newline.ele)
    return newline
  }

  /** 文字 */
  Text(x: number, y: number) {
    let newtext = new Text(x, y)
    this.ele.appendChild(newtext.ele)
    return newtext
  }

  /** 矩形，带像素修正 */
  Rect(x: number, y: number, width: number, height: number) {
    let newrect = new Rect(x, y, width, height)
    this.ele.appendChild(newrect.ele)
    return newrect
  }

  /** 折线，带精度修正 */
  Path(xylist: Array<{ x: number; y: number }>) {
    let newpath = new Path(xylist)
    this.ele.appendChild(newpath.ele)
    return newpath
  }

  /** 清除 */
  remove() {
    this.ele.remove()
  }
}

/**
 * 文字
 */
class Text {
  ele: SVGTextElement
  constructor(x: number, y: number) {
    this.ele = document.createElementNS("http://www.w3.org/2000/svg", "text")
    setAttr(this.ele, { x, y })
  }

  attr(options: { [key: string]: any }) {
    setAttr(this.ele, options)
  }
}

/**
 * 矩形
 */
class Rect {
  ele: SVGRectElement
  constructor(x: number, y: number, width: number, height: number) {
    this.ele = document.createElementNS("http://www.w3.org/2000/svg", "rect")
    setAttr(this.ele, {
      x: axisIntAdd(x),
      y: axisIntAdd(y),
      width: axisIntAdd(width - 1),
      height: height >= 2 ? Math.trunc(height) - 1 : 1,
    })
  }
  attr(options: { [key: string]: any }) {
    setAttr(this.ele, options)
  }
}

/**
 * 线段
 */
class Line {
  ele: SVGLineElement
  constructor(x1: number, y1: number, x2: number, y2: number) {
    this.ele = document.createElementNS("http://www.w3.org/2000/svg", "line")
    setAttr(this.ele, { x1, y1, x2, y2 })
  }

  attr(options: { [key: string]: any }) {
    setAttr(this.ele, options)
  }
}

/**
 * 横向线段
 */
class HLine {
  ele: SVGLineElement
  constructor(x: number, y: number, width: number) {
    this.ele = document.createElementNS("http://www.w3.org/2000/svg", "line")
    setAttr(this.ele, {
      x1: x,
      y1: axisIntAdd(y),
      x2: x + width,
      y2: axisIntAdd(y),
    })
  }

  attr(options: { [key: string]: any }) {
    setAttr(this.ele, options)
  }
}

/**
 * 竖向线段
 */
class VLine {
  ele: SVGLineElement
  constructor(x: number, y: number, height: number) {
    this.ele = document.createElementNS("http://www.w3.org/2000/svg", "line")
    setAttr(this.ele, {
      x1: axisIntAdd(x),
      y1: y,
      x2: axisIntAdd(x),
      y2: y + height,
    })
  }
  attr(options: { [key: string]: any }) {
    setAttr(this.ele, options)
  }
}

/**
 * 路径
 */
class Path {
  ele: SVGPathElement
  constructor(pathList: Array<{ x: number; y: number }>) {
    this.ele = document.createElementNS("http://www.w3.org/2000/svg", "path")
    let path_d: string[] = []
    pathList.map((v: any, index: number) => {
      if (index == 0) {
        path_d.push(`M ${parseFloat(v.x.toFixed(1))} ${parseFloat(v.y.toFixed(1))}`)
      } else {
        path_d.push(`L ${parseFloat(v.x.toFixed(1))} ${parseFloat(v.y.toFixed(1))}`)
      }
    })
    setAttr(this.ele, { d: path_d.join(" ") })
  }

  attr(options: { [key: string]: any }) {
    setAttr(this.ele, options)
  }
}

function setAttr(element: SVGElement, options: { [key: string]: any }) {
  Object.keys(options).map((option) => {
    element.setAttribute(option, options[option].toString())
  })
}

function axisIntAdd(input: number) {
  return Math.trunc(input) + 0.5
}
